import { render, staticRenderFns } from "./EventsCreate.vue?vue&type=template&id=587f8f7a&"
import script from "./EventsCreate.vue?vue&type=script&lang=ts&"
export * from "./EventsCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports